import { z } from "zod";

export const CentroCustoEnderecoSchema = z.object({
    idCentroCustoEndereco: z.coerce.number(),
    idCentroCusto: z.coerce.number(),
    idEndereco: z.coerce.number().optional(),
    tipoEndereco: z.string().optional(),
    principal: z.coerce.number().int().default(1),


    // endereco 
    rua: z.string().optional().nullable(),
    numero: z.string().trim().max(9, { message: "Máximo de 9 caracteres permitidos" }).optional().nullable(),
    apartamento: z.string().optional().nullable(),
    cep: z.string().optional().nullable(),
    uf: z.string().optional().nullable(),
    cidade: z.string().optional().nullable(),
    bairro: z.string().optional().nullable(),
    pais: z.string().optional().nullable(),

});

export type CentroCustoEnderecoForm = z.infer<typeof CentroCustoEnderecoSchema>;

export const defaultCentroCustoEnderecoForm: Partial<CentroCustoEnderecoForm> = {
    idCentroCustoEndereco: 0,
    principal: 1,
};
